import React, { Component } from 'react'
import "./loader.css";


export default class Loader extends Component {
  render() {
    return (
        <>
        {/* <div className="overlay"></div>
        <div className="spanner">
          <div className="loader"></div>
        </div> */}

<div className="loader-overlay">
  <div className="spinner-border" role="status">
    <span className="sr-only">Loading...</span>
  </div>
</div>
      </>
    )
  }
}
